import { RouteComponentProps, Router } from "@gatsbyjs/reach-router";
import TermPlanSummary from "./PolicyPlanSummary";

export default function OSBTermInsurance(props: RouteComponentProps) {
    return (
        <Router style={{ display: "flex", height: "100%" }}>
            <TermPlanSummary path="plan_summary" />
        </Router>
    );
}